import React, { useState, useEffect } from "react";

const NumericPadModal = ({ isOpen, onClose, onValidate, title, initialValue = "", unit = "kg" }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (isOpen) {
      setValue(initialValue ? String(initialValue) : "");
    }
  }, [isOpen, initialValue]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      if (e.key === "Enter") {
        onValidate(parseFloat(value) || 0);
      } else if (e.key === "Escape") {
        onClose();
      } else if (e.key === "," || e.key === ".") {
        e.preventDefault();
        handleInput(".");
      } else if (e.key === "Backspace") {
        handleBackspace();
      } else if (/^[0-9]$/.test(e.key)) {
        handleInput(e.key);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, value, onValidate, onClose]);

  const handleInput = (char) => {
    if (char === "." && value.includes(".")) return;
    setValue((prev) => prev + char);
  };

  const handleBackspace = () => {
    setValue((prev) => prev.slice(0, -1));
  };

  const handleClear = () => {
    setValue("");
  };

  if (!isOpen) return null;

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1055 }}>
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "12px" }}>
          <div className="modal-header border-bottom-0 pb-0">
            <h5 className="modal-title w-100 text-center">{title} <br/><small className="text-muted fs-6">Saisie en {unit}</small></h5>
            <button type="button" className="btn-close position-absolute top-0 end-0 m-3" onClick={onClose}></button>
          </div>
          <div className="modal-body p-4">
            <div className="mb-4">
              <label className="form-label text-info small fw-bold mb-1" style={{ color: "#0ea5e9" }}>MESURE ({unit.toUpperCase()})</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control form-control-lg fs-3 px-3 fw-bold"
                  value={value}
                  readOnly
                  style={{ height: "60px", letterSpacing: "1px", borderColor: "#0ea5e9" }}
                />
              </div>
            </div>
            
            <div className="row g-2">
              <div className="col-8">
                <div className="row g-2">
                  {[[7, 8, 9], [4, 5, 6], [1, 2, 3]].map((row, i) => (
                    <React.Fragment key={i}>
                      {row.map((num) => (
                        <div className="col-4" key={num}>
                          <button 
                            className="btn btn-light border w-100 py-3 fs-5 fw-bold" 
                            style={{ color: "#f97316" }} 
                            onClick={() => handleInput(String(num))}
                          >
                            {num}
                          </button>
                        </div>
                      ))}
                    </React.Fragment>
                  ))}
                  <div className="col-4">
                    <button className="btn btn-light border w-100 py-3 fs-5 fw-bold" style={{ color: "#f97316" }} onClick={() => handleInput("0")}>0</button>
                  </div>
                  <div className="col-4">
                    <button className="btn btn-light border w-100 py-3 fs-5 fw-bold" style={{ color: "#f97316" }} onClick={() => handleInput("00")}>00</button>
                  </div>
                  <div className="col-4">
                    <button className="btn btn-light border w-100 py-3 fs-5 fw-bold" style={{ color: "#f97316" }} onClick={() => handleInput(".")}>.</button>
                  </div>
                </div>
              </div>
              <div className="col-4 d-flex flex-column gap-2">
                <button className="btn btn-light border text-danger fw-bold flex-grow-1" onClick={handleBackspace}>
                  CORRIGER
                </button>
                <button className="btn btn-light border text-danger fw-bold flex-grow-1" onClick={handleClear}>
                  EFFACER
                </button>
              </div>
            </div>
            
            <div className="row g-2 mt-2">
               <div className="col-6">
                 <button className="btn btn-light border w-100 py-3 fw-bold text-muted" onClick={onClose}>
                   ANNULER
                 </button>
               </div>
               <div className="col-6">
                 <button className="btn w-100 py-3 fw-bold text-white" style={{ backgroundColor: "#22d3ee", borderColor: "#22d3ee" }} onClick={() => onValidate(parseFloat(value) || 0)}>
                   VALIDER
                 </button>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NumericPadModal;
